export default __webpack_public_path__ + "assets/b16db2f53d460bdd15ba00f5fcce9ef1.png";